import React from 'react';
import { Tooltip, TooltipProps } from '../../app/tooltip/tooltip';

export const WebTooltip: React.FC<Omit<TooltipProps, 'appearance'>> = (props) => (
    <Tooltip {...props} appearance="web" />
);
